import { pluralize } from '@gonfalon/format/pluralize';
import { TextTruncator } from '@gonfalon/ui/TextTruncator';
import { Text } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import { getMetricGroupKindDisplay } from '../../MetricKind';
import type { MetricGroupRep } from '../../types';

import styles from './MetricsSearch.module.css';

interface MetricGroupItemContentProps {
  metricGroup: MetricGroupRep;
}

function getConnectionCount(item: MetricGroupRep) {
  return (item?.experimentCount ?? 0) + (item?.guardedRolloutCount ?? 0) + (item?.releasePolicyCount ?? 0);
}

export function MetricGroupItemContent({ metricGroup }: MetricGroupItemContentProps) {
  const display = getMetricGroupKindDisplay(metricGroup.kind);
  return (
    <div className={styles.detailedListItem}>
      {display && <Icon name={display.displayIcon} size="small" className={styles.detailedListItemIcon} />}
      <div className={styles.detailedListItemContent}>
        <Text slot="label" className={styles.textTruncator}>
          <TextTruncator>{metricGroup.name}</TextTruncator>
        </Text>
        <Text slot="description" className={styles.metricGroupData}>
          <span>{metricGroup.metrics.length ?? 0} metrics</span>
          <span>
            {getConnectionCount(metricGroup)}{' '}
            {pluralize(getConnectionCount(metricGroup) ?? 0, 'connection', 'connections')}
          </span>
        </Text>
      </div>
    </div>
  );
}
